module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-5.d43df27b.mp3";